import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Route } from "react-router";
import PdfPage from "../../components/training/trainingPages/PdfPage";
import PowerpointPage from "../../components/training/trainingPages/PowerpointPage";

import VideoPage from "../../components/training/trainingPages/VideoPage";

const TrainingPages = (props) => {
  // console.log(
  //   "ReduxTrainingContent in pages =",
  //   props.reduxTrainingContent.trainingContent
  // );

  return (
    <>
      {props.reduxTrainingContent.trainingContent.map((trainingItem) => {
        const newPath = "/training/" + trainingItem.trainingData.tag;
        if (trainingItem.trainingData.format === "PowerPoint") {
          return (
            <Route exact path={newPath}>
              {/* {console.log("PowerPoint trainingItem =", trainingItem)}
              {console.log("newPath =", newPath)} */}
              <PowerpointPage pvUrl={trainingItem.trainingData.pvUrl} />
            </Route>
          );
        }
        if (trainingItem.trainingData.format === "Video") {
          return (
            <Route exact path={newPath}>
              {/* {console.log("Video trainingItem =", trainingItem)}
              {console.log("newPath =", newPath)} */}
              <VideoPage pvUrl={trainingItem.trainingData.tag} />
            </Route>
          );
        }
        if (trainingItem.trainingData.format === "PDF") {
          return (
            <Route exact path={newPath}>
              {/* {console.log("PDF trainingItem =", trainingItem)}
              {console.log("newPath =", newPath)}
              {console.log("pvUrl =", trainingItem.trainingData.tag)} */}
              <PdfPage pvUrl={trainingItem.trainingData.tag} />
            </Route>
          );
        }
      })}
      {/* <Route exact path="/videopage">
        <VideoPage />
      </Route>
      <Route exact path="/powerpointpage">
        <PowerpointPage />
      </Route>
      <Route exact path="/pdfpage">
        <PdfPage />
      </Route> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  // user: state.requestUserDataReducer.data,
  reduxTrainingContent: state.trainingContentReducer,
});

export default connect(mapStateToProps)(TrainingPages);
